module.exports = __webpack_public_path__ + "img/1.03394286.jpg";